import { render, staticRenderFns } from "./FiltroRepresentante.vue?vue&type=template&id=f523a712&"
import script from "./FiltroRepresentante.vue?vue&type=script&lang=js&"
export * from "./FiltroRepresentante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports